import { createAxiosInstance } from '~/plugins/axios.plugin';
import { validateQueryParameters } from '~/helpers/verifyQueryParameters';

export class Reports {
  static SERVICE_NAME = 'reports';

  constructor() {
    this.client = createAxiosInstance({
      baseURL           : process.env.REPORTS_API,
      useAccessToken    : true,
      addDefaultHeaders : false,
      customHeaders     : {
        'x-api-key'    : process.env.X_API_KEY_REPORTS,
        'Accept'       : 'application/json',
        'Content-Type' : 'application/json'
      }
    });

    this.genericClient = createAxiosInstance({
      baseURL           : '',
      useAccessToken    : true,
      addDefaultHeaders : false,
      customHeaders     : {
        'x-api-key'    : process.env.X_API_KEY_REPORTS,
        'Accept'       : 'application/json',
        'Content-Type' : 'application/json'
      }
    });

    this.functionURLClient = createAxiosInstance({
      baseURL           : '',
      useAccessToken    : false,
      addDefaultHeaders : false,
      customHeaders     : {
        'x-api-key'       : process.env.X_API_KEY_REPORTS,
        'Accept'          : 'application/json',
        'Content-Type'    : 'application/json',
        'x-authorization' : localStorage.getItem(`${process.env.APPLICATION_ALIAS}_accessToken`)
      }
    });
  }

  getReportList(params) {
    return this.client.get(`/reports/${params.section}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getReportStructure(params) {
    return this.client.get(`/reports/${params.section}/${params.reportId}${params.viewId ? `?viewId=${params.viewId}` : ''}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getFilterData(params) {
    const query = validateQueryParameters({
      filterType : params.filterType,
      page       : params.page,
      perPage    : params.itemsPerPage,
      search     : params.searchTerm,
      ids        : params.ids,
      ...params.parentValues
    });      
    return this.functionURLClient.get(`${params.endpoint}?${query}`, { cancelToken: params.cancelToken })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  getReportData({ filters, tableOptions, endpoint }) {
    const sortDirection = [];
    tableOptions.sortBy.forEach((item, index) => {
      const order = tableOptions.sortDesc[index] ? 'desc' : 'asc';
      sortDirection.push(`${item}:${order}`);
    });
    const query = validateQueryParameters({
      reportType : filters.reportType,
      page       : tableOptions.page,
      perPage    : tableOptions.itemsPerPage,
      search     : filters.search,
      sortBy     : sortDirection.join(),
      ...filters
    });
    return this.functionURLClient.get(`${endpoint}?${query}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));
  }

  postReportCSV({ filters, body, tableOptions, endpoint }) {
    const sortDirection = [];
    tableOptions.sortBy.forEach((item, index) => {
      const order = tableOptions.sortDesc[index] ? 'desc' : 'asc';
      sortDirection.push(`${item}:${order}`);
    });
    const query = validateQueryParameters({
      search : filters.search,
      sortBy : sortDirection.join(),
      ...filters
    });
    return this.genericClient.post(`${endpoint}?${query}`, body)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response.data.error));;
  }
}

export default new Reports();